import React, { useState } from 'react';
import { useAuth } from '../context/AuthContext';
import '../assets/css/auth.css';

const UpgradeModal = ({ isOpen, onClose }) => {
  const { user } = useAuth();
  const [upgradeStarted, setUpgradeStarted] = useState(false);
  
  if (!isOpen) return null;

  const handleUpgradeClick = async (price) => {
    let checkoutUrl;
    if (price === 'premium') {
      checkoutUrl = `https://buy.stripe.com/test_7sY00kcn97Ocd1C4fh7g403?client_reference_id=${user.currentFarm.id}&prefilled_email=${user.email}`;
    } else {
      checkoutUrl = `https://buy.stripe.com/test_7sY9AUevh7Oc7HibHJ7g402?client_reference_id=${user.currentFarm.id}&prefilled_email=${user.email}`;
    }
    window.open(checkoutUrl, '_blank');
    setUpgradeStarted(true);
  };

  const handleClose = () => {
    onClose();
    window.location.reload();
  };

  return (
    <div className="modal-overlay" onClick={handleClose}>
      <div className="modal-content" onClick={e => e.stopPropagation()}>
        <div className="modal-header">
          <h2>Wählen Sie Ihr Paket</h2>
          <button className="modal-close" onClick={handleClose}>
            <i className="fas fa-times"></i>
          </button>
        </div>
        <div className="modal-body">
          {upgradeStarted ? (
            <div className="upgrade-confirm-message">
              <h3>Upgrade durchgeführt?</h3>
              <p>Profil aktualisieren und Fenster schließen</p>
              <button className="upgrade-button" onClick={handleClose}>
                Jetzt aktualisieren & schließen
              </button>
            </div>
          ) : user.currentFarm.membership === 'premium' ? (
            <div className="premium-message">
              <h3>Sie sind bereits Premium-Mitglied!</h3>
              <p>Vielen Dank für Ihre Unterstützung. Sie genießen bereits alle Vorteile des Premium-Pakets.</p>
            </div>
          ) : (
          <div className="upgrade-options">
              {user.currentFarm.membership !== 'plus' && (
            <div className="upgrade-option">
                  <div className="content">
              <h3>Plus</h3>
              <div className="price">
                <span className="amount">16,90€</span>
                <span className="period">/Monat</span>
              </div>
              <ul>
                <li>Hofprofil & Produktkatalog</li>
                <li>10 Bilder in der Galerie</li>
                <li>2 Broadcasts pro Monat</li>
                <li>Chat-Funktion</li>
                <li>Post & Story Funktion</li>
                <li>Basis Statistiken</li>
              </ul>
                  </div>
              <button className="upgrade-button" onClick={() => handleUpgradeClick('plus')}>
                Jetzt starten
              </button>
            </div>
              )}
            <div className="upgrade-option premium">
                <div className="content">
              <h3>Premium</h3>
              <div className="price">
                <span className="amount">39,90€</span>
                <span className="period">/Monat</span>
              </div>
              <ul>
                <li>Alles aus Plus</li>
                <li>50 Bilder in der Galerie</li>
                <li>100 Broadcasts pro Monat</li>
                <li>Hervorgehobene Kartenposition</li>
                <li>Top-Platzierung in Suchergebnissen</li>
                <li>Erweiterte Statistiken</li>
              </ul>
                </div>
              <button className="upgrade-button" onClick={() => handleUpgradeClick('premium')}>
                Premium werden
              </button>
            </div>
          </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default UpgradeModal; 